import React from 'react';

import Button from '@components/uikit/Button/Button';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';
import Tabs from '@components/uikit/Tabs/Tabs';

import useTranslation from '@hooks/useTranslation';

import { useWhatsNewMarkViewedAllMutation } from '@pages/WhatsNew/services/useWhatsNewMarkViewedAllMutation';
import { selectWhatsNewIsFavorite, useWhatsNewActions } from '@pages/WhatsNew/store/useWhatsNewStore';

import { useWhatsNewCountQuery } from '@services/useWhatsNewCountQuery';

import style from './style.module.scss';

interface IProps {
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
}

const FilterPanel: React.FC<IProps> = ({ searchValue, setSearchValue }) => {
  const { t } = useTranslation();

  const { setWhatsNewIsFavorite } = useWhatsNewActions();

  const isFavorite = selectWhatsNewIsFavorite();

  const { data: whatsNewCount } = useWhatsNewCountQuery();
  const { mutate: whatsNewMarkViewedAllMutate } = useWhatsNewMarkViewedAllMutation();

  const newsFiltersList = [
    { value: 0, label: t('All') },
    { value: 1, label: t('Favorites') },
  ];

  return (
    <div>
      <div className={style.filtersPanel}>
        <Tabs
          id="whats-new-type"
          value={isFavorite}
          tabsItems={newsFiltersList}
          label={t('News')}
          type="woHelperText"
          onChange={setWhatsNewIsFavorite}
          variant="horizontal"
        />
        {!!whatsNewCount && (
          <Button
            type="secondary"
            text={t('Mark all as read')}
            onClick={whatsNewMarkViewedAllMutate}
          />
        )}
      </div>
      <div className={style.searchPanel}>
        <FilterSearch
          value={searchValue}
          onChange={(value) => setSearchValue(value || '')}
          placeholder={`${t('Search news')}...`}
          variant={'header-search'}
        />
      </div>
    </div>
  );
};

export default FilterPanel;
